import React, { useContext, useEffect } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import { CLEAR_WORK_DRAFT } from '@Const/work-registration-forms'
import { StoresContext } from '@App/contexts'
import CreateWorkManualDescription from '@Scenes/WorkScenes/CreateWorkManualScene/CreateWorkManualDescription'
import CreateWorkManualWorkSearch from '@Scenes/WorkScenes/CreateWorkManualScene/CreateWorkManualWorkSearch'
import RootStore from '@App/stores/root-store'

const CreateWorkManualScene = () => {
    const { workStore, createWorkSearchStore } = useContext<RootStore>(StoresContext)

    const initWorkDraft = () => workStore.setWorkDraftToLocal(CLEAR_WORK_DRAFT)

    useEffect(() => {
        initWorkDraft()
        return () => {
            createWorkSearchStore.clearWorkSearch()
        }
    }, [])

    return (
        <>
            <title>Create work manual</title>
            <div className="create-work-manual-scene">
                <div>
                    <div className="search-description-container">
                        <b>Search</b>
                        <CreateWorkManualDescription />
                    </div>

                    <CreateWorkManualWorkSearch />
                </div>
            </div>
        </>
    )
}

export default observer(CreateWorkManualScene)
